module.exports = __webpack_public_path__ + "img/shoyu_menu1.4d4a8fce.png";